import queryString from "query-string";
import { Navigate, useParams, useSearchParams } from "react-router-dom";

export default function MonitoringAlerts() {
  // (for now) redirect the stable alerts url to open the
  // issue/anomaly details modal in the portfolio view
  //
  // The target must stay absolute. A relative "portfolio" resolves against
  // the matched route (/monitoring/alerts/:alertId), giving
  // /monitoring/alerts/:alertId/portfolio -- which under react-router 7
  // matches back into this component and redirects again, appending
  // /portfolio forever until the tab runs out of memory. Router 6 happened to
  // settle after one extra hop, which is why this survived the upgrade.

  const [searchParams] = useSearchParams();
  const routeParams = useParams();
  const alertId = routeParams?.alertId;

  return (
    <Navigate
      to={{
        pathname: "/monitoring/portfolio",
        search: queryString.stringify({
          ...queryString.parse(searchParams.toString()),
          ...(alertId ? { issueId: alertId } : {}),
        }),
      }}
    />
  );
}
